/** Combining marks left over after NFD decomposition. */
const COMBINING_MARKS = /[\u0300-\u036f]/g;

/**
 * Characters NFD does not decompose — their diacritic is part of the glyph — plus
 * the ligatures, which fold to two letters.
 */
const FOLD_EXCEPTIONS: Record<string, string> = {
  ß: "ss",
  æ: "ae",
  œ: "oe",
  ø: "o",
  ł: "l",
  đ: "d",
  ð: "d",
  þ: "th",
  ħ: "h",
  ŧ: "t",
  ŋ: "n",
  ı: "i",
  ĳ: "ij",
};

export const foldDiacritics = (value: string): string =>
  Array.from(value.normalize("NFD").replace(COMBINING_MARKS, "").toLowerCase())
    .map((char) => FOLD_EXCEPTIONS[char] ?? char)
    .join("");
